site.megamenu = {
	init:function() {
		//site.megamenu.background();

		var $mainmenu = $('#mainmenu'),
			$body = $('body');
		$('.mmLevel2', $mainmenu).wrap('<div class="megamenu"><div class="wrap"><div class="contentWrap" /></div></div>');
		$mainmenu.on('click', function(e) {
			e.stopPropagation();
		});

		$('.level1.children > a',$mainmenu).on('click', function (e) {
			if ($(document).width()+15 >= 992) {
				e.preventDefault();
				e.stopPropagation();

				//Click on node that is already open
				if ($(this).parent().hasClass('open')) {
					site.megamenu.close();
				}
				//Open megamenu
				else {
					$('.level1.open', $mainmenu).removeClass('open');
					$body.removeClass('mmImage2');
					$body.removeClass('mmImage1');
					$('.megamenu', $mainmenu).removeAttr('style');
					$(this).parent().addClass('open');
					site.megamenu.setHeight();

					if (!$body.hasClass('megamenu-open')) {
						$body.addClass('megamenu-opening');
						setTimeout(function() {
							$body.removeClass('megamenu-opening');
							if (!$body.is('.megamenu-closing')) {
								$body.addClass('megamenu-open');
							}
						},600);
					}
				}

				//set body class for mm background image

				if($(this).parent().hasClass('last')) {
					document.body.classList.add("mmImage2");
				} else if ($(this).parent().hasClass('first')) {
					document.body.classList.add("mmImage1");
				}
			}
		});

		$body.on('click', function (e) {
			if ($body.hasClass('megamenu-open')) {
				site.megamenu.close();
			}
		});

		$(window).resize(function() {
			site.megamenu.setHeight();
		});
	},

	setHeight:function() {
		var $megamenu = $('.megamenu', '#mainmenu .level1.open');
		if ($megamenu.length > 0) {
			var $megamenuHeight = $('.megamenu .contentWrap', '#mainmenu .level1.open')[0].scrollHeight + 168;
			$('.megamenu', '#mainmenu').css('max-height', $megamenuHeight);
			$('#contentContainer').css('min-height', $megamenuHeight);
			//$('#megamenuBg').css('height', $megamenuHeight);
		}
	},

	close:function() {
		var $body = $('body'),
			$mainmenu = $('#mainmenu');
		$('.megamenu', $mainmenu).removeAttr('style');
		$('#contentContainer').removeAttr('style');

		if ($body.hasClass('megamenu-open') || $body.hasClass('megamenu-opening')) {
			$body.addClass('megamenu-closing');
			setTimeout(function() {
				$body.removeClass('megamenu-closing');
				$('.level1.open', $mainmenu).removeClass('open');
				$body.removeClass('mmImage2');
				$body.removeClass('mmImage1');
			},600);
		}
		$body.removeClass('megamenu-open');
	},

	background:function() {
		 var $banner = $('#front-banner');
		 var $header = $('header');

		 if($("body").hasClass("frontpage")) {
		 	$banner.before('<div id="megamenuBg" />');
		 } else {
		 	$header.append('<div id="megamenuBg" />')
		 }

		 $('#megamenuBg').on('click touchstart', function(e) {
			 e.stopPropagation();
		 });
	}
};
